export const GLOBAL_SEARCH_RECENTS_FILTERS = ["all", "people", "facilities", "jobs", "activities"] as const;

export type GlobalSearchRecentsFilter = (typeof GLOBAL_SEARCH_RECENTS_FILTERS)[number];

export type GlobalSearchColumn = "search" | "recents";

export const GLOBAL_SEARCH_FILTER_ORDER = GLOBAL_SEARCH_RECENTS_FILTERS;

export const GLOBAL_SEARCH_FILTER_LABELS: Record<GlobalSearchRecentsFilter, string> = {
  all: "All",
  people: "People",
  facilities: "Facilities",
  jobs: "Jobs",
  activities: "Activities"
};

export function recentsEmptyTitle(filter: GlobalSearchRecentsFilter): string {
  if (filter === "all") return "No Recently Visited Items";
  return `No Recently Visited ${GLOBAL_SEARCH_FILTER_LABELS[filter]}`;
}

export function searchEmptyTitle(query: string, filter: GlobalSearchRecentsFilter): string {
  if (filter === "all") return query.trim() ? "No matching pages or records" : "No matching pages";
  return `No matching ${GLOBAL_SEARCH_FILTER_LABELS[filter].toLowerCase()}`;
}

export function entitySearchFailedTitle(filter: GlobalSearchRecentsFilter): string {
  if (filter === "people") return "Couldn't load people";
  if (filter === "facilities") return "Couldn't load facilities";
  if (filter === "jobs") return "Couldn't load jobs";
  if (filter === "activities") return "Couldn't load activities";
  return "Couldn't load records";
}

export function cycleGlobalSearchFilter(
  current: GlobalSearchRecentsFilter,
  direction: 1 | -1
): GlobalSearchRecentsFilter {
  const index = GLOBAL_SEARCH_FILTER_ORDER.indexOf(current);
  const start = index >= 0 ? index : 0;
  const next = (start + direction + GLOBAL_SEARCH_FILTER_ORDER.length) % GLOBAL_SEARCH_FILTER_ORDER.length;
  return GLOBAL_SEARCH_FILTER_ORDER[next] ?? "all";
}

export function matchesSearchFilter(
  kind: "page" | "people" | "facilities" | "jobs" | "activities",
  filter: GlobalSearchRecentsFilter
): boolean {
  if (filter === "all") return true;
  if (filter === "people") return kind === "people";
  if (filter === "facilities") return kind === "facilities";
  if (filter === "jobs") return kind === "jobs";
  if (filter === "activities") return kind === "activities";
  return false;
}
